<template>
  <div class="component-form">
    <h1 class="form-title">Homework/Final Exam</h1>
    <p class="text mt-30">
      A template (below) has been provided for your convenience when designing your homework and final exam. Please create a copy of the document and replace
      all the highlighted fields with relevant information pertaining to your seminar. When finished, please upload an editable document to the SL Portal, and
      click submit.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload">Homework Template</Button>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload"
      :acceptType="['DOC', 'DOCX', 'PAGES']"
      :value="value.file"
      @input="handleInput($event, 'file')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Button, FileUploader } from '../../../../components/form';
import { Message } from 'element-ui';
export default {
  name: 'HomeworkExam',
  components: {
    Button,
    FileUploader
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ROLES() {
      return ROLES;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      Message({
        type: 'error',
        message: '暂未开放'
      });
    }
  }
};
</script>
